const OPERATION_LOG_EXPORT_TAB_BY_LOG_TAB = {
  successes: {
    tab: 'work_done',
    label: 'work done'
  },
  errors: {
    tab: 'errors',
    label: 'errors'
  },
  warnings: {
    tab: 'warnings',
    label: 'warnings'
  }
};

export const getWorkflowOperationLogExportTab = (selectedTab) => OPERATION_LOG_EXPORT_TAB_BY_LOG_TAB[selectedTab]?.tab || 'work_done';

export const getWorkflowOperationLogExportLabel = (selectedTab) => OPERATION_LOG_EXPORT_TAB_BY_LOG_TAB[selectedTab]?.label || 'work done';
